module.exports = __webpack_public_path__ + "media/images/flags/16/American-Samoa-df300a2900b395d9e700d3fee5e448bf.png";